import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { formatCurrency } from '../../services/adminAnalyticsApi';

const COLORS = ['#1a2f5c', '#ef4444', '#10b981'];

const CommissionBreakdownChart = ({ gross = 0, tax = 0, net = 0 }) => {
  const data = [
    { name: 'Net Commission', value: Number(net) || 0 },
    { name: 'Withholding Tax', value: Number(tax) || 0 },
  ].filter((d) => d.value > 0);

  const total = (Number(gross) || 0) || data.reduce((s, d) => s + d.value, 0);

  if (!total) {
    return (
      <div className="ab-card">
        <div className="ab-card-header"><h3 className="ab-card-title">Commission Split</h3></div>
        <div className="ab-card-body ab-empty">No commission data for the current filters.</div>
      </div>
    );
  }

  return (
    <div className="ab-card">
      <div className="ab-card-header">
        <div>
          <h3 className="ab-card-title">Commission Split</h3>
          <p className="ab-page-subtitle">Net vs withholding tax on gross {formatCurrency(gross)}</p>
        </div>
      </div>
      <div className="ab-card-body">
        <div style={{ height: 240 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} cx="50%" cy="50%" innerRadius={55} outerRadius={85} paddingAngle={3} dataKey="value" stroke="none">
                {data.map((_, i) => (
                  <Cell key={i} fill={COLORS[i + 1] || COLORS[0]} />
                ))}
              </Pie>
              <Tooltip formatter={(v) => formatCurrency(v)} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default CommissionBreakdownChart;
